import { get, post, fileDown} from "@/utils/request";

import apiMap from "@/config";

const riskApi = apiMap.riskApi

// export const getSysOrderExport = (data, fileName) =>
//   fileDown(`${riskApi}/risk/riskSysOrder/exportExcel`, data, fileName);
  
export const getRiskflagList = (data) =>
  get(`${riskApi}/risk/riskOrder/findRiskFlagList`, data);

export const updateRiskflag = (data) =>
  post(`${riskApi}/risk/riskOrder/updateOrderRiskFlag`, data);
